import { css } from '@emotion/css';

export const styActionButtonsContainer = css`
  display: flex;
  gap: 8px;
`;

export const styDetail = css`
  display: flex;
  gap: 30px;
  padding: 12px;

  > div {
    display: flex;
    gap: 8px;
    flex-direction: column;

    > div {
      display: flex;
      gap: 8px;
      white-space: nowrap;

      > :first-child {
        font-weight: 700;
      }
    }
  }
`;
